/**
 * Height of the sparkline height according to table row spacing
 */
export const sparklineHeights = {
    1: 17,
    0: 15,
    2: 13
};